<template>
  <div v-show="AIPackageWindowShow">
    <div class="AIPackageWindow">
      <div class="AIPackageWindow_content">
        <div class="AIPackageWindow_content_title">
          <div class="content_title_left"><span></span>AISEO套餐价格</div>
          <div class="content_title_right" @click="closeWindow"><i class="el-icon-close"></i></div>
        </div>
        <div class="AIPackageWindow_content_txt ShopCombo ShopCombo2">
          <div class="ShopComboContent">
            <!-- 渲染套餐列表 -->
            <div v-for="(packageItem, index) in packageList" :key="packageItem.id" class="ShopComboContent_list">
              <div class="ShopComboContent_list_top">
                <div class="list_top_dd font24">{{ packageItem.name }}</div>
                <div class="list_top_dt font12">{{ packageItem.describe }}</div>
                <div class="list_top_icon"><img src="@a/seo/crown.svg"></div>
              </div>
              <div class="ShopComboContent_list_bottom">
                <div class="list_bottom_time font14"><span class="font30">￥{{ packageItem.money }}</span>期限365天</div>
                <router-link
                  :to="{ path: '/writing/SeoOrders', query: { payId: packageItem.id }}"
                  class="list_bottom_btn font14"
                  @click.native="closeWindow"
                >立即购买</router-link>
                <div class="list_bottom_con">
                  <div class="bottom_con_list font12">
                    <div class="btn_list_left">创作积分</div>
                    <div class="btn_list_right">{{ packageItem.integral }}积分</div>
                  </div>
                  <div class="bottom_con_list font12">
                    <div class="btn_list_left">绑定站点</div>
                    <div class="btn_list_right">{{ packageItem.bind_sites }}个</div>
                  </div>
                  <div class="bottom_con_list font12">
                    <div class="btn_list_left">发布计划</div>
                    <div class="btn_list_right">{{ packageItem.plan }}个</div>
                  </div>
                  <div class="bottom_con_list font12">
                    <div class="btn_list_left">文章配图</div>
                    <div class="btn_list_right" style="font-size: 18px; height: 10px; display: flex; align-items: center;">
                      <span :style="{ color: packageItem.article_images === 1 ? 'green' : 'red' }">
                        {{ packageItem.article_images === 1 ? '✔' : '✘' }}
                      </span>
                    </div>
                  </div>
                  <div class="bottom_con_list font12">
                    <div class="btn_list_left">文章链轮</div>
                    <div class="btn_list_right" style="font-size: 18px; height: 10px; display: flex; align-items: center;">
                      <span :style="{ color: packageItem.article_link === 1 ? 'green' : 'red' }">
                        {{ packageItem.article_link === 1 ? '✔' : '✘' }}
                      </span>
                    </div>
                  </div>
                  <div class="bottom_con_list font12">
                    <div class="btn_list_left">其他功能不限制</div>
                    <div class="btn_list_right"><img src="@a/seo/sv21.svg"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';

export default {
  name: "SeoOrders",
  data() {
    return {
      AIPackageWindowShow: true,
      packageList: [], // 存储套餐列表
    };
  },
  methods: {
    // 关闭窗口
    closeWindow() {
      this.AIPackageWindowShow = false;
      this.$emit('close');
    },

    // 获取AI套餐列表
    async getAiSeoPayList() {
      try {
        const res = await this.axios.get('api/products/getAiSeoPayList'); // 请求套餐接口
        if (res.code === 1) {
          this.packageList = res.result.map(item => ({
            id: item.id,
            name: item.name,
            describe: item.describe,
            money: item.money,
            integral: item.integral,
            bind_sites: item.seo_level.website || 0,
            plan: item.seo_level.plan || 0,
            article_images: item.seo_level.is_image || 0,
            article_link: item.seo_level.is_url || 0,
          }));
          console.log("套餐列表数据:", this.packageList);
        } else {
          console.error("接口返回错误:", res);
        }
      } catch (error) {
        console.error("获取AI套餐列表时出错:", error);
      }
    },
  },
  created() {
    this.getAiSeoPayList(); // 组件创建时请求套餐列表
  }
};
</script>

<style>
@import "AIPackageWindow.css";
</style>